import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegisterForm } from 'src/app/website/register/register-form';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailregisterService {
    constructor(private http:HttpClient) { }

    registerMail(rf: RegisterForm): Observable<any>{
      return this.http.post<any[]>(environment.apiUrl + "api/Contact/register",rf);
    }
}
